import { makeEntityScaffold } from '@classpass/saga-tools';

export const venueList = makeEntityScaffold('SAGA.API.VENUES', (client, options, overrides) =>
  client.venues.getList(options, overrides).then(data => ({
    venues: data.venues,
    meta: data.meta
      ? {
          numPages: data.meta.num_pages,
          currentPage: data.meta.current_page,
          totalCount: data.meta.total_count,
        }
      : {},
  }))
);

export const venueListV2 = makeEntityScaffold('SAGA.API.VENUES_V2', (client, options, overrides) =>
  client.venues.getListV2(options, overrides).then(data => ({
    venues: data.venues,
    meta: data.meta
      ? {
          numPages: data.meta.num_pages,
          currentPage: data.meta.current_page,
          totalCount: data.meta.total_count,
        }
      : {},
  }))
);

export const venueByIdV2 = makeEntityScaffold(
  'SAGA.API.VENUE_BY_ID_V2',
  (client, venueId, options) => client.venues.getVenueByIdV2(venueId, options),
  { defaultKey: 1 }
);

export const scheduleForVenue = makeEntityScaffold(
  'SAGA.API.SCHEDULE_FOR_VENUE',
  (client, venueId, options) => client.venues.getSchedulesPerVenue(venueId, options).then(data => data.schedules),
  { defaultKey: 1 }
);

export const similarVenues = makeEntityScaffold(
  'SAGA.API.SIMILAR_VENUES',
  (client, venueId, options) => client.venues.getVenueSimilarities(venueId, options).then(data => data.venues),
  { defaultKey: 1 }
);

export const reviewsForVenue = makeEntityScaffold(
  'SAGA.API.REVIEWS_FOR_VENUE',
  (client, venueId, page = 0, pageSize = 25) =>
    client.venues.getVenueReviews(venueId, {
      page_size: pageSize,
      page: parseInt(page, 10),
      meta: true,
    }),
  { defaultKey: [1, 2] }
);

export const reviewsForVenueV2 = makeEntityScaffold(
  'SAGA.API.REVIEWS_FOR_VENUE_V2',
  (client, venueId, page = 0, pageSize = 4, limitFeatured = 3) =>
    client.venues.getVenueReviewsV2(venueId, {
      limit_featured: limitFeatured,
      page_size: pageSize,
      page: parseInt(page, 10),
    }),
  { defaultKey: [1, 2] }
);

export const venueOtherLocations = makeEntityScaffold(
  'SAGA.API.VENUE_SIBLINGS',
  (client, venueId, options) => client.venues.getVenueSiblings(venueId, options),
  { defaultKey: 1 }
);

export const nearbyPopularVenues = makeEntityScaffold(
  'SAGA.API.NEARBY_POPULAR_VENUES',
  (client, msaId, overrides) =>
    client.venues.getNearbyPopularVenue(msaId, overrides).then(data => ({
      venues: data.venues,
      meta: data.meta
        ? {
            numPages: data.meta.num_pages,
            currentPage: data.meta.current_page,
            totalCount: data.meta.total_count,
          }
        : {},
    })),
  { defaultKey: 1 }
);
